<template>
  <component :is="as" class="helper-text">
    <slot />

    <helper-icon
      :help-text="helpText"
      :hide-help="hideHelp"
    />
  </component>
</template>

<script>
import HelperIcon from './HelperIcon';

export default {
  components: {
    HelperIcon,
  },

  props: {
    as: {
      type: String,
      default: 'span',
    },
    hideHelp: Boolean,
    helpText: String,
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.helper-text {
  display: inline-flex;
  align-items: center;
}
</style>
